import type { SortDirection } from '@/types/common.types'

import type {
  StockReportExportFormat,
  StockReportSortField,
  StockReportStatusFilter,
} from './types/stock-report.types'

export const STOCK_REPORT_QUERY_KEY = ['stock-report'] as const

export const STOCK_REPORT_LIMIT_OPTIONS = [10, 25, 50, 100] as const
export const STOCK_REPORT_DEFAULT_LIMIT = STOCK_REPORT_LIMIT_OPTIONS[1]
export const STOCK_REPORT_MAX_LIMIT = 100

export const STOCK_REPORT_DEFAULT_STATUS: StockReportStatusFilter = 'low'
export const STOCK_REPORT_DEFAULT_SORT_BY: StockReportSortField = 'name'
export const STOCK_REPORT_DEFAULT_SORT_DIRECTION: SortDirection = 'asc'

export const STOCK_REPORT_STATUS_FILTERS = [
  'all',
  'low',
  'out',
  'normal',
] as const satisfies readonly StockReportStatusFilter[]

export const STOCK_REPORT_SORT_FIELDS = [
  'name',
  'externalId',
  'onHand',
  'threshold',
  'shortage',
] as const satisfies readonly StockReportSortField[]

export const STOCK_REPORT_EXPORT_FORMATS = [
  'csv',
  'xlsx',
] as const satisfies readonly StockReportExportFormat[]

export const STOCK_REPORT_EXPORT_FILENAME_PREFIX = 'reporte-stock'
